import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { throwError } from 'rxjs';
import { Store } from '../store';
import { ToastrService } from 'ngx-toastr';
import {environment} from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ApiService {

    constructor(
        private store: Store,
        private toastr: ToastrService,
    ) {
    }

    path() {
        return 'https://api.ysprod.co.uk/';
        // return 'http://localhost:3000/';
    }

    getHttpOptions() {
        const domain = this.store.selectForLocal('domain')
        const headers: any = {
            'domain': domain,
            'api-key': '6bf9284a-ebf9-4afa-a185-4d2b9bb29e85',
        }
        if (environment.emulateSslForLocalDev) {
            headers['x-forwarded-proto'] = true
        }
        return {
            headers: new HttpHeaders(headers),
            withCredentials: true,
        };
    }

    handleError = (error: HttpErrorResponse) => {
        this.toastr.error('', `Oops something didn't quite work`);
        if (error.error instanceof ErrorEvent) {
            console.error('An error occurred:', error.error.message);
        } else {
            console.error(
                `Backend returned code ${error.status}, ` +
                `body was: ${error.error}`);
        }
        return throwError(
            'Something bad happened; please try again later.');
    };

}
